import React, {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  PropsWithChildren,
} from 'react';
import { classnames } from '@/utils/classnames';

export interface IUnderlinedTextProps
  extends PropsWithChildren<
    DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>
  > {}

const UnderlinedText: FC<IUnderlinedTextProps> = ({
  children,
  className,
  ...props
}) => (
  <span
    className={classnames(
      'border-b border-dashed border-green-20',
      props?.onClick && 'cursor-pointer',
      className
    )}
    {...props}
  >
    {children}
  </span>
);

export default UnderlinedText;
